import { render, staticRenderFns } from "./AccessPointDetails.vue?vue&type=template&id=ec944612&scoped=true"
import script from "./AccessPointDetails.vue?vue&type=script&lang=js"
export * from "./AccessPointDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec944612",
  null
  
)

export default component.exports